<span class="identity-initials"> {{ profile?.firstName?.charAt(0) }} {{ profile?.lastName?.charAt(0) }} </span>

<profile-personal-identity [profile]="profile" [loading]="loading?.PERSONAL_IDENTITY"></profile-personal-identity>
